/* eslint-disable no-unused-expressions */
import BaseComponent from 'foundation/base-component';
import React from 'react';
import { render } from 'react-dom';
import Cookies from 'js-cookie';
import BasketController from '../../../general/js/basket/basket-controller';
import Basket from './basket';
import basketProductsHelper from '../../../general/js/basket/basket-products-helper';
import { safeParseJSON, stringToBoolean } from '../../../general/js/general-helpers';

export default class BasketComponent extends BaseComponent {
    constructor(...args) {
        super(...args);
        this.init();
    }

    init() {
        const {
            isBallotBasketType, showAlertBoxBeforePayment, dialogBoxTitle, dialogBoxLogo, secutixBallotReservedProducts
        } = this.options;
        const dialogBoxBanner = {
            bannerBackgroundImageSrc: this.options.bannerBackgroundImageSrc,
            bannerMessage: this.options.bannerMessage,
            bannerTitle: this.options.bannerTitle,
            displayHeadingOverImage: stringToBoolean(this.options.displayHeadingOverImage),
            displayMessageUnderImage: stringToBoolean(this.options.displayMessageUnderImage),
            textColor: this.options.textColor,
            headingColor: this.options.headingColor
        };
        const errorsCookie = Cookies.get('validationErrors');
        const hasBallotConfiguration = JSON.parse(isBallotBasketType.toLowerCase());
        const hasAlertBoxBeforePayment = JSON.parse(showAlertBoxBeforePayment.toLowerCase());
        const dialogBoxMessage = this.options.dialogBoxMessage.split('newline').join('\n');

        errorsCookie !== undefined ? this.errors = safeParseJSON(errorsCookie) : this.errors = [];

        basketProductsHelper.setSecutixReservedProducts(secutixBallotReservedProducts);

        render(
            (
                <BasketController
                    isConfiguredForBallot={hasBallotConfiguration}
                    masterCardDiscount={this.options.masterCardDiscount}
                    render={({ basket, onUpdateProductQuantity, onCheckout }) =>
                        <Basket basket={basket}
                            errors={this.errors}
                            onUpdateProductQuantity={onUpdateProductQuantity}
                            onCheckout={onCheckout}
                            hasBallotConfiguration={hasBallotConfiguration}
                            showAlertBoxBeforePayment={hasAlertBoxBeforePayment}
                            dialogBoxTitle={dialogBoxTitle}
                            dialogBoxMessage={dialogBoxMessage}
                            dialogBoxLogo={dialogBoxLogo}
                            dialogBoxBanner={dialogBoxBanner}/>
                    }>
                </BasketController>
            ),
            this.element
        );
    }
}
